<template>
  <div class="banner-list">
    <el-carousel
      height="100vh"
      width="100vw"
      ref="carousel"
      :interval="interval"
      :autoplay="true"
      trigger="click"
      @change="beforeChange"
    >
      <el-carousel-item v-for="(item, index) in bannerList" :key="index">
        <div
          class="banner-item"
          :data-index="index"
          v-if="item.type === 'video'"
        >
          <video
            class="banner-bg banner-video"
            id="video"
            ref="videoPlayer"
            :src="item.src"
            muted
            autoplay="false"
            loop
            x-webkit-airplay="allow"
            x5-video-player-type="h5"
            x5-video-player-fullscreen="true"
          ></video>
        </div>
        <div
          class="banner-item"
          :data-index="index"
          v-if="item.type === 'image'"
        >
          <img class="banner-bg banner-image" :src="item.src" alt="图片" />
          <div class="banner-content">
            <div class="title pre-wrap">
              <span v-html="item.title"></span>
            </div>
            <div class="subtitle">{{ item.subtitle }}</div>
          </div>
        </div>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
export default {
  data() {
    return {
      interval: 5000, // 轮播间隔时间
      isIn: true, // 控制视频是否显示控制条
      timer: null, // 定时器
    };
  },
  computed: {
    bannerList() {
      console.log("获取banner列表: ", this.$t("home").bannerList);
      return this.$t("home").bannerList;
    },
  },
  methods: {
    beforeChange(newIndex, oldIndex) {
      console.log("切换前", newIndex, oldIndex);
      this.prepareChange(newIndex);
    },
    prepareChange(newIndex) {
      if (this.bannerList[newIndex]) {
        if (this.timer) {
          clearTimeout(this.timer);
        }
        this.interval = this.bannerList[newIndex].duration || 5000; // 设置新的轮播间隔时间
      } else {
        const video = this.$refs.videoPlayer;
        if (video) {
          video.pause();
          video.controls = false; // 确保视频控制条被隐藏
        }
      }
    },
  },
  mounted() {
    // 初始化时设置轮播间隔
    this.prepareChange(0);
  },
};
</script>

<style scoped lang="scss">
.banner-list {
  .banner-item {
    .banner-bg {
      width: 100vw;
      height: 100vh;
      object-fit: cover;
    }
    .banner-content {
      position: absolute;
      width: 70rem;
      height: 10rem;
      left: 50%;
      margin-left: -35rem;
      top: 50%;
      margin-top: -5rem;
      .title,
      .subtitle {
        font-style: normal;
        font-weight: 600;
        font-size: 2.6rem;
        color: rgba(255, 255, 255, 0.85);
        letter-spacing: 0.5rem;
      }
      .subtitle {
        margin-top: 0.93rem;
        font-weight: 400;
        font-size: 1.12rem;
        line-height: 1.87rem;
        color: rgba(255, 255, 255, 0.65);
        letter-spacing: 0.35rem;
      }
    }
    &[data-index="0"] .banner-content {
      text-align: center;
      gap: 1.25rem;
      .title,
      .subtitle {
        text-shadow: 0 0.25rem 0.5rem rgba(0, 0, 0, 0.45),
          0 0.5rem 1.5625rem rgba(0, 0, 0, 0.25),
          0 0.75rem 2.8125rem rgba(0, 0, 0, 0.25);
      }
      .title {
        font-size: 3rem;
        line-height: 3.875rem;
      }
      .subtitle {
        color: rgba(255, 255, 255, 0.85);
        font-size: 2.25rem;
        font-weight: 600;
        line-height: 1.5;
        margin-top: 1.5rem;
      }
    }
  }
  .el-carousel {
    width: 100vw !important;

    ::v-deep .el-carousel__container {
      position: relative;
      width: 100vw !important;
    }

    ::v-deep .el-carousel__arrow {
      width: 2.5rem;
      border: 0.01rem solid white;
      display: block !important;
    }

    ::v-deep .el-carousel__arrow i {
      height: 1rem !important;
      line-height: 1rem !important;
      font-size: 1rem !important;
      text-align: center;
      color: transparent;
    }

    ::v-deep .el-carousel__arrow--left,
    ::v-deep .el-carousel__arrow--right {
      width: 2.5rem !important;
      height: 2.5rem !important;
      margin-left: 1.8rem;
      background: url("@/static/img/right-arrow.png") no-repeat 0.8rem 0.7rem;
      background-size: 1rem 1rem;
      background-position: center center;
      transform: rotate(180deg);
      /* 旋转角度，可根据需要调整 */
    }

    ::v-deep .el-carousel__arrow--right {
      margin-right: 1.8rem;
      margin-left: auto;
      transform: none;
    }

    ::v-deep .el-carousel__indicators {
      margin-bottom: 1.25rem;
    }
  }
}
</style>
